/**
 * MSAL + Dataverse configuration for the GAQ Compose app.
 *
 * Entra app registration: dedicated `GAQ Compose` reg (Andy's decision
 * 2026-06-01 — mirrors Pipeline's own-reg approach rather than reusing the
 * shared `Getaquote Compliance Checklist` reg the spec originally named).
 * Keeping a dedicated reg means Stage 2's Outlook/Graph Mail scopes can be
 * added here without over-privileging Checklists/Renewals.
 *   - App (client) ID: fe7b687f-70b4-407a-a36c-a7173066e36e
 *   - Object ID:       4b9a7664-a56b-4d15-a4ae-24f0f485ec7c
 *   - Audience: AzureADMyOrg (Getaquote single-tenant)
 *   - Platform: SPA (Auth Code + PKCE)
 *   - SPA redirect URIs registered 2026-06-01:
 *       http://localhost:5175/                                  (local dev)
 *       https://compose.getaquoteltd.co.uk/                     (custom domain)
 *       https://mango-moss-09d6c4a03.7.azurestaticapps.net/     (SWA default host)
 *
 * Treat the client ID as a public config constant — safe to commit.
 */

export const TENANT_ID = '4ff95d23-d9e1-4623-b4a7-857c183aa335';
export const CLIENT_ID = 'fe7b687f-70b4-407a-a36c-a7173066e36e';
export const DATAVERSE_URL = 'https://org8670ff58.crm11.dynamics.com';

/**
 * Entra does exact-string matching on redirectUri (trailing slash
 * included). Always emit origin + '/'.
 */
const redirectUri =
  typeof window !== 'undefined' ? `${window.location.origin}/` : '/';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage' as const,
    storeAuthStateInCookie: false,
  },
};

/** Scope for Dataverse Web API calls. */
export const dataverseScopes = [`${DATAVERSE_URL}/user_impersonation`];

/** Scopes for the silent login (Microsoft profile). */
export const profileScopes = ['User.Read'];

/**
 * Stage 2 note (Outlook via Microsoft Graph — Andy's decision 2026-05-31):
 * when email drafting lands, request Graph Mail scopes here
 * (e.g. ['Mail.ReadWrite', 'Mail.Send']) as an INCREMENTAL consent on top
 * of the Dataverse scope — do NOT bundle them into dataverseScopes. Keeping
 * them separate means Stage 1 users aren't prompted for Mail consent they
 * don't yet need, and the app reg's delegated permissions can be added when
 * Stage 2 starts without disturbing Stage 1.
 */
